export default function () {	
	
  $(document).on('ready', function() {

    $('<div class="quantity-button quantity-up">+</div>').insertAfter('.quantity input');
    $('<div class="quantity-button quantity-down">-</div>').insertBefore('.quantity input');

    $('.quantity').each(function() {
      var spinner = jQuery(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find('.quantity-up'),
      btnDown = spinner.find('.quantity-down'),
      min = 1,
      max = 20;

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        var newVal;
        if (oldValue >= max) {
          newVal = oldValue;
        } else {
          newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        var newVal;
        if (oldValue == min) {
          newVal = oldValue;
        } else {
          newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

    });

	});
}



// WEBPACK FOOTER //
// ./scripts/components/SetupNumberButtons.js